import { type LoadErrorStatus, type TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";

export const setTableViewLoadingMutator: (tableView: TableView) => void = mutatorAction("setTableViewLoading", (tableView: TableView): void => {
    tableView.isInitialLoadComplete = false;
    tableView.loadErrorStatus = 0;
    tableView.loadErrorCode = undefined;
});
